import React from 'react';
import { modelClass } from '/imports/api/inventoryPolicies';
import { ModelListPage } from '/imports/ui/ModelListPage';

export const InventoryPoliciesPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[
      { field: 'name', label: 'Name' },
      { field: 'description', label: 'Description' },
      {
        field: 'defaultQty', label: 'Target Qty',
        render: (p) => ((p as any).defaultQty ?? <span className="text-fg-3">inherit</span>),
      },
      {
        field: 'defaultAdQty', label: 'Advertised Qty',
        render: (p) => ((p as any).defaultAdQty ?? <span className="text-fg-3">inherit</span>),
      },
      {
        field: 'rules', label: 'Rules',
        render: (p) => ((p as any).rules?.length ?? 0),
      },
    ]}
  />
);
